import React, { useState, useEffect, useCallback, useRef } from "react";
import Axios from "axios";
import { connect } from "react-redux";
import * as actions from "../../../store/actions/index";
import Spinner from "../../../components/Spinner/Spinner";
import VariableProduct from "./variableProduct";
import Joi from "joi";
import { withRouter } from "react-router-dom";
import md5 from "md5";
import { timestamp } from "../../../firebase/index";
import QuillEditor from "../../../components/UI/QuillEditor/QuillEditor";
import DynamicKeyValue from "../../../components/UI/DynamicKeyValue/DynamicKeyValue";
import ReactCustomSelect from "../../../components/UI/ReactCustomSelect/ReactCustomSelect";
import { getDateFromTime, getInputDateFromTime } from "../../../store/utility";

const AddProduct = (props) => {
  const [variable, setVariable] = useState(false);
  const [images, setImages] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);
  const [brands, setBrands] = useState(null);
  const [selectedCategory, setCategory] = useState(null);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [inputProduct, setProduct] = useState({
    productTitle: "",
    productDesc: "",
    keyFeatures: "",
    categoryId: "",
    subcategoryId: "",
    productTypeId: "",
    brand: "",
    brandId: "",
    salePrice: null,
    regularPrice: null,
    variable: false,
    variableStock: {},
    gender: [], //Strictly gender should be an array
    previewImages: [
      // "https://firebasestorage.googleapis.com/v0/b/k5-dev.appspot.com/o/2t5lTHLgjc1CvAHLcnDs%2Frob0HqfP7GvQBuOzGdfff5af%2F3a17Ticket.png?alt=media&token=dccce826-5e1f-4778-bba1-12cac9cedcf7",
      // "https://firebasestorage.googleapis.com/v0/b/k5-dev.appspot.com/o/2t5lTHLgjc1CvAHLcnDs%2Frob0HqfP7GvQBuOzGdfff5af%2F82f8Screenshot%202021-07-15%20at%2011.45.44%20AM.png?alt=media&token=455a16bc-1394-4a62-8a61-9cf5e547dc70",
      // "https://firebasestorage.googleapis.com/v0/b/k5-dev.appspot.com/o/2t5lTHLgjc1CvAHLcnDs%2Frob0HqfP7GvQBuOzGdfff5af%2F2474Screenshot%202021-07-28%20at%2010.02.43%20PM.png?alt=media&token=b493e236-d2a8-4026-aa8b-6fef45397562",
      // "https://firebasestorage.googleapis.com/v0/b/k5-dev.appspot.com/o/2t5lTHLgjc1CvAHLcnDs%2Frob0HqfP7GvQBuOzGdfff5af%2Fcaf7Screenshot%202021-07-15%20at%2011.51.47%20AM.png?alt=media&token=961672aa-06cc-4d02-9129-41490a0b2ba5",
      // "https://firebasestorage.googleapis.com/v0/b/k5-dev.appspot.com/o/2t5lTHLgjc1CvAHLcnDs%2Frob0HqfP7GvQBuOzGdfff5af%2F4de3Screenshot%202021-07-15%20at%2011.43.52%20AM.png?alt=media&token=f250c719-a420-4a3a-a337-8201167ea231",
      // "https://firebasestorage.googleapis.com/v0/b/k5-dev.appspot.com/o/2t5lTHLgjc1CvAHLcnDs%2Frob0HqfP7GvQBuOzGdfff5af%2F8363Screenshot%202021-06-27%20at%205.07.00%20PM.png?alt=media&token=3c2d8d24-bb1a-46aa-ba23-81ebe3d40a1a",
      // "https://firebasestorage.googleapis.com/v0/b/k5-dev.appspot.com/o/2t5lTHLgjc1CvAHLcnDs%2Frob0HqfP7GvQBuOzGdfff5af%2F481cScreenshot%202021-06-07%20at%2012.54.29%20PM.png?alt=media&token=a2665b4c-9730-472c-b141-ef17ccc4fa23",
      // "https://firebasestorage.googleapis.com/v0/b/k5-dev.appspot.com/o/2t5lTHLgjc1CvAHLcnDs%2Frob0HqfP7GvQBuOzGdfff5af%2F389aScreenshot%202021-07-01%20at%203.29.59%20PM.png?alt=media&token=970f6a35-81c4-44a3-b56f-98922a8e8cc5",
    ],
    weight: null,
    stock: null,
    variants: [],
    expiry: "",
    additionalInfo: {},
  });

  // const [inputProduct,setProduct] = useState(

  //   productData[0]

  // )
  const [showImageModal, setImageModal] = useState(false);
  const [batch, setBatch] = useState(4);
  const [imageBuffer, setImageBuffer] = useState({});
  const [isAddPreviewImage, setPreview] = useState(false);
  const [variant, setVariant] = useState(null);

  const scroller = useRef(null);
  const loader = useRef(null);
  let bufferId = null;
  if (selectedCategory && selectedSubcategory) {
    bufferId = selectedCategory.id + selectedSubcategory.id;
  }

  const alertUser = (e) => {
    e.preventDefault();
    e.returnValue = "";
    alert("Are you sure?");
  };

  useEffect(() => {
    props.onFetchBrands();
    props.fetchCategory();
    props.onFetchProductTypes();
    setCategory(props.category);
    setBrands(props.brands);

    // props.fetchAttribute();
    //Prompt on Refresh
    window.addEventListener("beforeunload", alertUser);
    return () => {
      window.removeEventListener("beforeunload", alertUser);
    };
  }, []);
  //Edit Product Initiliaztion.-----------------
  useEffect(() => {
    let product = props.editProduct;
    // console.log("Edit Product", product);
    if (product && !inputProduct.categoryId) {
      let selectedSubcategory = {
        id: product.subcategoryId,
        name: product.subcategoryName,
      };
      setProduct(product);
      setSelectedSubcategory(selectedSubcategory);
      setVariable(product.variable);
    }
    if (product && props.category && !selectedCategory) {
      let category = props.category.filter(
        (charge) => charge.id == product.categoryId
      )[0];
      // let selectedCategory = {id:product.categoryId,categoryName:product.categoryName,}
      setCategory(category);
    }
  }, [props.editProduct, props.category]);

  function handleScroll() {
    // let scrollpane = document.getElementById("REACT_SCROLLPANE");
    let scrollpane = scroller.current;
    let spST = scrollpane.scrollTop;
    let spSH = scrollpane.clientHeight;

    //let rsH = document.getElementById("REACT_LOADER_RESULTS").scrollHeight;
    let rsH = loader.current.scrollHeight;
    // console.log(spSH+spST,rsH-5)
    //spSH+spST+100>rsH
    if (spSH + spST > rsH - 5) {
      try {
        let images = props.images;
        let lastImage = imageBuffer[bufferId][imageBuffer[bufferId].length - 1];
        let lastImageIndex = images.indexOf(lastImage);
        let newImages = images.splice(lastImageIndex + 1, batch);
        let updatedBuffer = imageBuffer[bufferId].concat(newImages);
        let _imageBuffer = { ...imageBuffer };
        let uniqueBuffer = [...new Set(updatedBuffer)];
        _imageBuffer[bufferId] = uniqueBuffer;
        setImageBuffer(_imageBuffer);
      } catch (error) {}
    }
  }

  useEffect(() => {
    if (props.images) {
      if (!imageBuffer[bufferId]) {
        setImageBuffer({
          ...imageBuffer,
          [bufferId]: props.images.splice(0, batch),
        });
      }
    }
  }, [props.images]);

  useEffect(() => {
    if (props.images) {
      scroller.current.addEventListener("scroll", handleScroll);
      return function () {
        try {
          scroller.current.removeEventListener("scroll", handleScroll);
        } catch (error) {}
      };
      // return () =>  scroller.current.removeEventListener("scroll", handleScroll);
    }
  }, [props.images, imageBuffer[bufferId]]);

  const handleChange = useCallback((event) => {
    let { name, value } = event.target;

    if (!isNaN(Number(value)) && value) {
      value = parseInt(value);
    }
    if (name == "subcategoryId") {
      let sc = selectedCategory.subcategories.filter((sc) => sc.id == value)[0];
      if (sc) {
        setSelectedSubcategory(sc);
        setProduct({
          ...inputProduct,
          [name]: value,
          subcategoryName: sc.name,
        });
      }
    } else if (name == "brandId") {
      let brand = props.brands.filter((bobj) => bobj.id == value)[0];

      if (brand) {
        setProduct({ ...inputProduct, [name]: value, brand: brand.name });
      }
    } else if (name == "expiry") {
      // console.log(value);
      setProduct({ ...inputProduct, [name]: new Date(value).getTime() });
    } else {
      setProduct({ ...inputProduct, [name]: value });
    }
  });

  const handleCategoryChange = (categoryId) => {
    // let categoryId = e.target.value;

    let chargeType = props.category.filter(
      (charge) => charge.id == categoryId
    )[0];

    setCategory(chargeType);
    setSelectedSubcategory(null);
    setProduct({
      ...inputProduct,
      categoryId: categoryId,
      categoryName: chargeType.categoryName,
      subcategoryId: "",
      subcategoryName: "",
    });
  };

  const handleUploadChange = (e) => {
    // let image = images.concat();
    // for (let i = 0; i < e.target.files.length; i++) {
    //   const singleImg = e.target.files[i];
    //   image.push({ singleImg });
    // }
    // console.log([...image,...e.target.files])
    // setImages([...image,...e.target.files]);
    if (e.target.files.length == 1) {
      setImages([e.target.files[0]]);
    } else {
      setImages(e.target.files);
    }
  };

  const handleGalleryClick = () => {
    if (!(selectedCategory && selectedSubcategory)) {
      // $("ImageGalleryModal").hide()
      return alert("Please Select Category and Subcategory");
    }
    setPreview(false);
    let categoryId = inputProduct.categoryId;
    let subcategoryId = inputProduct.subcategoryId;
    props.onFetchImages(categoryId, subcategoryId);
    // setImageModal(true);
  };

  const handleImageCheck = (e, image) => {
    // console.log(e.target.id,e.target.checked)
    let imageUrl = image;
    let imageArray = selectedImages;
    if (imageArray.includes(imageUrl)) {
      imageArray = imageArray.filter((item) => item !== imageUrl);
    } else {
      imageArray.push(imageUrl);
    }
    setSelectedImages(imageArray);
    // console.log(imageArray);
  };

  const handleImageUpload = async (e) => {
    try {
      e.preventDefault();
      let categoryId = inputProduct.categoryId;
      let subcategoryId = inputProduct.subcategoryId;
      let imageUrls = await props.onUploadImages(
        categoryId,
        subcategoryId,
        images
      );
      // console.log(imageUrls)
      let updatedBuffer = [...imageUrls, ...imageBuffer[bufferId]];
      let _imageBuffer = { ...imageBuffer };
      _imageBuffer[bufferId] = updatedBuffer;
      setImageBuffer(_imageBuffer);
      document.getElementById("productImagesUpload").value = "";
      // setImageBuffer([...imageUrls,...imageBuffer])
    } catch (error) {}
  };

  const handleImageDelete = async (e) => {
    try {
      e.preventDefault();

      let categoryId = inputProduct.categoryId;
      let subcategoryId = inputProduct.subcategoryId;
      let deletedImages = await props.onDeleteImages(
        categoryId,
        subcategoryId,
        selectedImages
      );

      let buffer = imageBuffer[bufferId].concat();

      deletedImages.map((image) => {
        const index = buffer.indexOf(image);
        if (index > -1) {
          buffer.splice(index, 1);
        }
      });

      let _imageBuffer = { ...imageBuffer };
      _imageBuffer[bufferId] = buffer;
      setImageBuffer(_imageBuffer);
      return setSelectedImages([]);
    } catch (error) {}
  };

  const switchToPreviewModal = () => {
    try {
      if (!(selectedCategory && selectedSubcategory)) {
        return alert("Please Select Category and Subcategory");
      }

      setPreview(true);
      setSelectedImages([]);
      document.getElementById("ImageGalleryModalBtn").click();
    } catch (error) {
      return alert(error);
    }
  };
  const addPreviewImages = () => {
    try {
      if (variable) {
        //Variable product
        // console.log(variant);
        if (variant) {
          let previewImages = [];
          if (variant.previewImages) {
            previewImages = variant.previewImages.concat();
          }
          selectedImages.map((image) => {
            if (!previewImages.includes(image)) {
              previewImages.push(image);
            }
          });
          let _variant = variant;
          _variant["previewImages"] = previewImages;
          // console.log(_variant);
          setVariant(_variant);
          setSelectedImages([]);
          document.getElementById("ImageGalleryModalBtn").click();
          // setVariant(null);
        } else {
          return alert("Variant is null in addProduct");
        }
      } else {
        //Single Product
        let previewImages = inputProduct.previewImages.concat();
        // console.log(selectedImages)
        selectedImages.map((image) => {
          if (!previewImages.includes(image)) {
            previewImages.push(image);
          }
        });
        setProduct({ ...inputProduct, previewImages: previewImages });
        setSelectedImages([]);
        document.getElementById("ImageGalleryModalBtn").click();
      }
    } catch (error) {
      return alert(error);
    }
  };
  const removePreviewImages = (image, variantId, variants) => {
    if (variable) {
      let __variant = variants.filter((v) => v.variantId == variantId)[0];

      // console.log(__variant)
      // let __variant = variant;
      // console.log(__variant);
      if (__variant) {
        let images = __variant.previewImages.concat();
        const index = images.indexOf(image);
        if (index > -1) {
          images.splice(index, 1);
        }
        // let __variant = variant;
        __variant["previewImages"] = images;

        // setVariant(__variant);
        // console.log('Setting Variant',__variant);
        return __variant;
      } else {
        return alert("Variant is null in addProduct");
      }
    } else {
      let images = inputProduct.previewImages.concat();
      const index = images.indexOf(image);
      if (index > -1) {
        images.splice(index, 1);
      }
      setProduct({ ...inputProduct, previewImages: images });
    }
  };

  const singleProductSchema = Joi.object({
    id: Joi.string().required(),
    brand: Joi.string().max(50).required(),
    brandId: Joi.string().required(),
    categoryId: Joi.string().required(),
    categoryName: Joi.string().max(50).required(),
    previewImages: Joi.array().min(1).required(),
    productDesc: Joi.string().required(),
    productTitle: Joi.string().required(),
    productTypeId: Joi.string().required(),
    regularPrice: Joi.number().min(1).required(),
    salePrice: Joi.number().min(1).required(),
    stock: Joi.number().min(1).required(),
    weight: Joi.number().min(1).required(),
    subcategoryId: Joi.string().required(),
    subcategoryName: Joi.string().max(50).required(),
    variable: Joi.boolean().required(),
    variants: Joi.optional(),
    rating: Joi.optional(),
    reviewCount: Joi.optional(),
    searchSpace: Joi.optional(),
    timestamp: Joi.optional(),
    variableStock: Joi.optional(),
    someStockOut: Joi.optional(),
    keyFeatures: Joi.optional(),
    additionalInfo: Joi.object().optional(),
    expiry: Joi.optional(),
    filters: Joi.optional(),
    gender: Joi.array(),
  });

  const handleSingleSubmit = (e) => {
    e.preventDefault();

    if (variable) {
      return alert("Not a Single Product");
    }
    if (!inputProduct.id) {
      inputProduct["id"] = md5(md5(inputProduct) + Math.random() * 1000000000);
    }
    if (!inputProduct.timestamp) {
      inputProduct["timestamp"] = timestamp.now().seconds * 1000;
    }
    let { error } = singleProductSchema.validate(inputProduct);
    if (error) {
      return alert(error);
    } else {
      props.onAddSingleProduct(inputProduct);
    }
  };

  return (
    <React.Fragment>
      <div>
        <div className="dropdown">
          {!props.editProduct && (
            <button
              className="btn btn-secondary btn-sm dropdown-toggle my-2 mx-4"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Product Type
            </button>
          )}
          {!props.editProduct && (
            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <a
                className="dropdown-item"
                // href="#"
                onClick={() => (
                  setVariable(false),
                  setProduct({
                    ...inputProduct,
                    variable: false,
                  })
                )}
              >
                Single
              </a>
              <a
                className="dropdown-item"
                // href="#"
                onClick={() => (
                  setVariable(true),
                  setProduct({
                    ...inputProduct,
                    variable: true,
                  })
                )}
              >
                Variable
              </a>
            </div>
          )}

          {!props.editProduct && (
            <p className="d-inline">
              {!inputProduct.variable ? "Single Product" : "Variable Product"}
            </p>
          )}
          {inputProduct.categoryId == "" ||
          inputProduct.subcategoryId == "" ||
          selectedSubcategory == null ? null : (
            <button
              type="button"
              className="btn btn-primary btn-sm float-right my-2 mx-4"
              data-toggle="modal"
              data-target=".bd-example-modal-lg"
              onClick={handleGalleryClick}
              id="ImageGalleryModalBtn"
            >
              Image Gallery
            </button>
          )}

          {
            <div
              className="modal fade bd-example-modal-lg"
              tabindex="-1"
              role="dialog"
              aria-labelledby="myLargeModalLabel"
              aria-hidden="true"
              id="ImageGalleryModal"
            >
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">
                      Image Gallery for {inputProduct.categoryName}/
                      {inputProduct.subcategoryName}
                    </h5>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={(e) => e.preventDefault()}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    {!isAddPreviewImage && (
                      <div>
                        <input
                          type="file"
                          className="btn btn-success btn-sm"
                          style={{ backgroundColor: "green" }}
                          accept="image/*"
                          id="productImagesUpload"
                          onChange={handleUploadChange}
                          multiple
                        />
                      </div>
                    )}
                    {!isAddPreviewImage && <hr />}
                    {props.loadingImg ? (
                      <Spinner />
                    ) : (
                      <div
                        className="row container"
                        ref={scroller}
                        style={{ height: "300px", overflow: "auto" }}
                      >
                        {
                          props.images && (
                            //  <ImageGridWithBuffer  images={props.images} batch={4}/>

                            <div
                              ref={loader}
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                justifyContent: "space-between",
                              }}
                            >
                              {imageBuffer[bufferId] &&
                                imageBuffer[bufferId].map((imageObj, index) => (
                                  <div
                                    className="form-check pt-3"
                                    key={`formX${index}`}
                                    style={{ paddingLeft: "2.3rem" }}
                                  >
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      name={imageObj}
                                      id={`checkbox${index}`}
                                      onChange={(e) =>
                                        handleImageCheck(e, imageObj)
                                      }
                                    />
                                    <img
                                      // className={classes.Image}
                                      src={imageObj}
                                      alt={imageObj}
                                      style={{
                                        width: "200px",
                                        height: "200px",
                                      }}
                                    />
                                  </div>
                                ))}
                            </div>
                          )

                          // props.images.map((image, index) => (
                          //   <div className="form-check col-md-2">
                          //     <input
                          //       className="form-check-input"
                          //       type="checkbox"
                          //       name={image}
                          //       id="flexCheckDefault"
                          //       onChange={handleImageCheck}
                          //     />
                          //     <img
                          //       src={image}
                          //       key={index}
                          //       className=""
                          //       height="50rem"
                          //     />
                          //   </div>
                          // ))
                        }
                      </div>
                    )}
                  </div>
                  <div className="modal-footer">
                    {!isAddPreviewImage && (
                      <>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleImageUpload}
                          disabled={props.uploadImagesLoading}
                        >
                          {props.uploadImagesLoading ? "Saving" : "Upload"}
                        </button>
                        <button
                          // type="button"
                          className="btn btn-secondary btn-sm"
                          onClick={handleImageDelete}
                          disabled={props.deleteImagesLoading}
                        >
                          {props.deleteImagesLoading ? "Deleting" : "Delete"}
                        </button>
                      </>
                    )}
                    {isAddPreviewImage && (
                      <div className="text-center w-100">
                        <button
                          className="btn btn-success"
                          onClick={addPreviewImages}
                        >
                          Save
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
      <div className="mx-4 mt-4">
        <form onSubmit={handleSingleSubmit}>
          <div className="form-row">
            <div className="form-group col-md-6">
              <label for="inputTitle">Title</label>
              <input
                name="productTitle"
                type="text"
                required
                className="form-control"
                id="inputTitle"
                placeholder="Title"
                value={inputProduct.productTitle}
                onChange={handleChange}
              />
            </div>
            <div className="form-group col-md-3">
              <label for="inlineFormSelCat">Category</label>

              <select
                name="categoryId"
                required
                className="custom-select my-1 mr-sm-2"
                id="inlineFormSelCat"
                value={inputProduct.categoryId}
                onChange={(e) => handleCategoryChange(e.target.value)}
                required
              >
                <option value="">Select...</option>
                {props.category &&
                  props.category.map((singleCategory, index) => (
                    <option key={index} value={singleCategory.id}>
                      {singleCategory.categoryName}
                    </option>
                  ))}
              </select>
            </div>
            {selectedCategory ? (
              <div className="form-group col-md-3">
                <label for="inlineFormSelSubCat">SubCategory</label>
                <select
                  name="subcategoryId"
                  required
                  className="custom-select my-1 mr-sm-2"
                  id="inlineFormSelSubCat"
                  value={inputProduct.subcategoryId}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select...</option>
                  {selectedCategory.subcategories &&
                    selectedCategory.subcategories.map((subcategory, index) => (
                      <option key={index} value={subcategory.id}>
                        {subcategory.name}
                      </option>
                    ))}
                </select>
              </div>
            ) : null}
          </div>
          <div className="form-row">
            <div className="form-group col-md-6">
              <label for="productDescEditor">Description</label>

              <div>
                <QuillEditor
                  id="productDescEditor"
                  toolbar={true}
                  value={inputProduct.productDesc}
                  setValue={(value) =>
                    setProduct({ ...inputProduct, productDesc: value })
                  }
                />
              </div>
            </div>
            {!variable ? (
              <div className="form-group col-md-6">
                <label for="keyFeaturesEditor">Key Features</label>

                <div>
                  <QuillEditor
                    id="keyFeaturesEditor"
                    toolbar={true}
                    value={inputProduct.keyFeatures}
                    setValue={(value) =>
                      setProduct({ ...inputProduct, keyFeatures: value })
                    }
                  />
                </div>
              </div>
            ) : (
              <div className="form-row col-md-6">
                <div className="form-group col-md-4">
                  <label for="inlineFormSelBrand">Brand</label>

                  <select
                    name="brandId"
                    required
                    className="custom-select my-1 mr-sm-2"
                    id="inlineFormSelBrand"
                    value={inputProduct.brandId}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select...</option>
                    {props.brands &&
                      props.brands.map((brand, index) => (
                        <option key={index} value={brand.id}>
                          {brand.name}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="form-group col-md-4">
                  <label for="inlineFormSelType">Product Type</label>
                  <select
                    name="productTypeId"
                    required
                    className="custom-select my-1 mr-sm-2"
                    id="inlineFormSelType"
                    value={inputProduct.productTypeId}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select...</option>
                    {props.productTypes &&
                      props.productTypes.map((productType, index) => (
                        <option key={index} value={productType.id}>
                          {productType.name}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="form-group col-md-4">
                  <label>Gender</label>
                  <div>
                    <ReactCustomSelect
                      optionSelected={inputProduct.gender}
                      handleChange={(selected) =>
                        setProduct({
                          ...inputProduct,
                          gender: selected,
                        })
                      }
                    />
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="form-row">
            {!variable && (
              <div className="form-group col-md-4">
                <label for="inlineFormSelBrand">Brand</label>

                <select
                  name="brandId"
                  required
                  className="custom-select my-1 mr-sm-2"
                  id="inlineFormSelBrand"
                  value={inputProduct.brandId}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select...</option>
                  {props.brands &&
                    props.brands.map((brand, index) => (
                      <option key={index} value={brand.id}>
                        {brand.name}
                      </option>
                    ))}
                </select>
              </div>
            )}
            {!variable && (
              <div className="form-group col-md-4">
                <label for="inlineFormSelType">Product Type</label>
                <select
                  name="productTypeId"
                  required
                  className="custom-select my-1 mr-sm-2"
                  id="inlineFormSelType"
                  value={inputProduct.productTypeId}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select...</option>
                  {props.productTypes &&
                    props.productTypes.map((productType, index) => (
                      <option key={index} value={productType.id}>
                        {productType.name}
                      </option>
                    ))}
                </select>
              </div>
            )}
            {!variable && (
              <div className="form-group col-md-4">
                <label for="inputExpiry">Expiry</label>
                <input
                  name="expiry"
                  type="date"
                  className="form-control"
                  id="inputExpiry"
                  placeholder="Expiry (Optional)"
                  value={
                    inputProduct.expiry
                      ? getInputDateFromTime(inputProduct.expiry)
                      : inputProduct.expiry
                  }
                  onChange={handleChange}
                />
              </div>
            )}
          </div>

          {variable ? null : (
            <React.Fragment>
              <div className="form-row">
                <div className="form-group col-md-3">
                  <label for="salePriceIp">Selling Price</label>
                  <input
                    name="salePrice"
                    required
                    min={1}
                    type="number"
                    className="form-control"
                    id="salePriceIp"
                    value={inputProduct.salePrice}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group col-md-3">
                  <label for="regPriceIP">Regular Price</label>
                  <input
                    name="regularPrice"
                    type="number"
                    required
                    min={1}
                    className="form-control"
                    id="regPriceIP"
                    value={inputProduct.regularPrice}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group col-md-2">
                  <label for="inputStock">Stock</label>
                  <input
                    name="stock"
                    min={1}
                    required
                    type="number"
                    className="form-control"
                    id="inputStock"
                    value={inputProduct.stock}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group col-md-2">
                  <label for="inputWeight">Weight (in grams)</label>
                  <input
                    name="weight"
                    min={1}
                    required
                    type="number"
                    className="form-control"
                    id="inputWeight"
                    value={inputProduct.weight}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group col-md-2">
                  <label>Gender</label>
                  <div>
                    <ReactCustomSelect
                      optionSelected={inputProduct.gender}
                      handleChange={(selected) =>
                        setProduct({
                          ...inputProduct,
                          gender: selected,
                        })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group col-md-2">
                  <button
                    id="singleProductPreview"
                    type="button"
                    className="btn btn-info btn-sm form-control"
                    onClick={() => {
                      switchToPreviewModal();
                      setPreview(true);
                    }}
                  >
                    Add Images
                  </button>
                </div>
                <div className="form-group col text-center">
                  <label>Preview Images</label>
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      border: "1px solid grey",
                      borderRadius: "4px",
                      display: "flex",
                      overflowY: "auto",
                    }}
                  >
                    {inputProduct.previewImages &&
                      inputProduct.previewImages.map((image) => (
                        <div className="m-3 d-flex">
                          <div
                            style={{ cursor: "pointer", fontSize: "18px" }}
                            onClick={() => removePreviewImages(image, null)}
                          >
                            <i className="fa fa-times" aria-hidden="true"></i>
                          </div>
                          <img
                            src={image}
                            alt={image}
                            style={{ width: "150px", height: "150px" }}
                          />
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
          {!variable && (
            <div style={{ width: "90%" }}>
              <DynamicKeyValue
                dataObj={inputProduct.additionalInfo}
                setDataObj={(data) =>
                  setProduct({ ...inputProduct, additionalInfo: data })
                }
              />
            </div>
          )}

          <div className="form-row">
            {!variable && (
              <div
                className="w-100 text-center mt-5"
                style={{ position: "relative" }}
              >
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={props.singleSubmitLoading}
                >
                  {props.singleSubmitLoading ? "Adding" : "Add Product"}
                </button>
              </div>
            )}
          </div>
        </form>
        <div className="m-4">
          {variable && (
            <VariableProduct
              product={inputProduct}
              setProduct={setProduct}
              addPreviewImages={addPreviewImages}
              removePreviewImages={removePreviewImages}
              switchToPreviewModal={(varint) => {
                switchToPreviewModal();
                setVariant(varint);
                setPreview(true);
              }}
              variant={variant}
              isEdit={props.editProduct ? true : false}
            />
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    brands: state.brands.brands,
    loading: state.brands.loading,
    category: state.category.categories,
    loadingImg: state.gallery.loading,
    images: state.gallery.images,
    uploadImagesLoading: state.gallery.uploadImagesLoading,
    deleteImagesLoading: state.gallery.deleteImagesLoading,
    productTypes: state.general.productTypes,
    singleSubmitLoading: state.products.singleSubmitLoading,
    attributes: state.attributes.attribute,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchProductTypes: () => dispatch(actions.onFetchProductTypes()),
    onFetchBrands: () => dispatch(actions.onFetchBrands()),
    fetchCategory: () => dispatch(actions.fetchCategoryAdmin()),
    onFetchImages: (cid, sid) => dispatch(actions.onFetchImages(cid, sid)),
    onUploadImages: (cid, sid, images) =>
      dispatch(actions.onUploadImages(cid, sid, images)),
    onDeleteImages: (cid, sid, images) =>
      dispatch(actions.onDeleteImages(cid, sid, images)),
    onAddSingleProduct: (product) =>
      dispatch(actions.onAddSingleProduct(product)),
    //fetchAttribute: () => dispatch(actions.fetchAttribute()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AddProduct, Axios));
